import { useCallback, useEffect, useRef } from 'react';

type ResponseFunctionType = {
  turnOnSetTimeout: () => void;
  clearTimeoutLoading: () => void;
};

const DELAY_TIME = 1000;

function useDelayIsLoading(
  setIsGlobalLoading: (loading: boolean) => void,
): ResponseFunctionType {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const clearTimeoutLoading = useCallback((): void => {
    if (timerRef.current !== null) clearTimeout(timerRef.current);
    timerRef.current = null;
    setIsGlobalLoading(false);
  }, [setIsGlobalLoading]);
  const turnOnSetTimeout = useCallback((): void => {
    if (timerRef.current !== null) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setIsGlobalLoading(true), DELAY_TIME);
  }, [setIsGlobalLoading]);

  useEffect(
    () => () => {
      if (timerRef.current !== null) clearTimeoutLoading();
    },
    [clearTimeoutLoading],
  );

  return { turnOnSetTimeout, clearTimeoutLoading };
}

export { useDelayIsLoading };
